import { render, staticRenderFns } from "./orderPaymentCopy.vue?vue&type=template&id=084e130a&scoped=true&"
import script from "./orderPaymentCopy.vue?vue&type=script&lang=js&"
export * from "./orderPaymentCopy.vue?vue&type=script&lang=js&"
import style0 from "./orderPaymentCopy.vue?vue&type=style&index=0&id=084e130a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084e130a",
  null
  
)

export default component.exports